import {css} from 'emotion';

import uiColors from 'components/Colors/colors';
import fonts from 'static/three-oh/src/modules/constants/fonts';

const borderWidth = '1px';

const container = css`
  border-radius: 0 0 4px 4px;
  padding: 24px;

  box-shadow: 0 16px 24px 0 rgba(0, 0, 0, 0.16);
  border: solid ${borderWidth} #d9d9d9;
  border-top: none;
  background-color: ${uiColors.white[0]};

  &:before {
    content: " ";
    background-image: linear-gradient(to left, #0076ae, #250056 50%);
    width: calc(100% + (${borderWidth} * 2));
    height: 4px;
    top: -4px;
    position: absolute;
    left: -${borderWidth};
  }
`;

const closeIcon = css`
  width: 32px;
  height: 35px;
  line-height: 32px;
  text-align: center;
  cursor: pointer;
`;

const title = css`
  font-size: ${fonts.sizes.l};
  line-height: 1.5;
  height: 35px;
  font-weight: bold;

  display: flex;
  justify-content: space-between;
`;

const body = css`
  margin-top: 30px;
`;

export default {
  container,
  title,
  closeIcon,
  body,
};
